export const STEP_TYPE_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'longtext', label: 'Long Text' },
  { value: 'select', label: 'Select' },
  { value: 'slider', label: 'Slider' },
  { value: 'linked', label: 'Linked Field' },
  { value: 'confirmation', label: 'Confirmation' },
  { value: 'lookup', label: 'Lookup (user)' },
  { value: 'date', label: 'Date' },
  { value: 'stop', label: 'Dead Stop' },
];

export const getStepTypeLabel = stepType => STEP_TYPE_OPTIONS.find(o => o.value === stepType)?.label ?? stepType;

export const getStepTypeColour = stepType => {
  switch (stepType) {
    case 'stop':
      return 'red';
    case 'select':
    case 'confirmation':
      return 'blue';
    case 'lookup':
    case 'linked':
      return 'purple';
    case 'date':
    case 'slider':
      return 'cyan';
    default:
      return 'default';
  }
};

export const CONDITION_EFFECT_OPTIONS = [
  { value: 'hide', label: 'Hide section' },
  { value: 'disable', label: 'Show section disabled (blocks completion)' },
];

export const getConditionEffect = node => (node?.conditionEffect === 'disable' ? 'disable' : 'hide');

export const UNARY_OPERATORS = ['!', '!!'];
export const isUnaryOperator = op => UNARY_OPERATORS.includes(op);

const OPERATOR_LABELS = { '!': 'is empty', '!!': 'is not empty' };
export const getOperatorLabel = op => OPERATOR_LABELS[op] ?? op;
